import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _ACTION_HANDLERS;

import produce from 'immer';
import _set from 'lodash/set'; // Utils

import { tget } from '../../utils/general'; // Helpers

import createReducer from '../../helpers/createReducer'; // Constants

import { EMPTY_OBJECT } from '../../app.constants';
import ACTION_TYPES from './useFetchData.actionTypes';
var handleSetData = produce(function (state) {
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : EMPTY_OBJECT;
  var data = tget(action, 'payload.data');

  _set(state, 'data', data);

  _set(state, 'isLoading', false);

  _set(state, 'hasError', false);
});
var handleInitializeFetching = produce(function (state) {
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : EMPTY_OBJECT;
  var params = tget(action, 'payload.params');

  _set(state, 'isLoading', true);

  _set(state, 'cachedDependencies', params);
});
var handleSetError = produce(function (state) {
  _set(state, 'isLoading', false);

  _set(state, 'hasError', true);
});
var ACTION_HANDLERS = (_ACTION_HANDLERS = {}, _defineProperty(_ACTION_HANDLERS, ACTION_TYPES.SET_DATA, handleSetData), _defineProperty(_ACTION_HANDLERS, ACTION_TYPES.SET_ERROR, handleSetError), _defineProperty(_ACTION_HANDLERS, ACTION_TYPES.INITIALIZE_FETCHING, handleInitializeFetching), _ACTION_HANDLERS);
var REDUCER = createReducer(ACTION_HANDLERS);
export default REDUCER;